import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class PrivacyPolicyController implements Controller {
  public pageId = 'PrivacyPolicy';
  public path = '/:localeName/privacy-policy';
  public routeName = 'privacy-policy';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "privacy-policy-page" */ '../views/privacy-policy-page'),
  );
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Privacy Policy' }) as Promise<PageData>;
  }
}
